"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var $ = require("jquery");
var ko = require("knockout");
var moment = require("moment");
var _ = require("lodash");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var baseViewModel_1 = require("./base/baseViewModel");
var richContentUtils_1 = require("../utils/richContentUtils");
var stringUtils_1 = require("../../app/utils/stringUtils");
var imageZoomUtils_1 = require("../../app/utils/imageZoomUtils");
require("signalr");
var director = require("director");
var PrivacyPrivateMessage;
(function (PrivacyPrivateMessage) {
    PrivacyPrivateMessage[PrivacyPrivateMessage["None"] = 0] = "None";
    PrivacyPrivateMessage[PrivacyPrivateMessage["All"] = 1] = "All";
    PrivacyPrivateMessage[PrivacyPrivateMessage["OnlyFriends"] = 2] = "OnlyFriends";
})(PrivacyPrivateMessage || (PrivacyPrivateMessage = {}));
var BaseChat = (function () {
    function BaseChat(data, viewModel) {
        var _this = this;
        this.lastActivity = ko.observable().extend({ notify: "always" });
        this.lastMessageId = ko.observable();
        this.lastMessageText = ko.observable();
        this.lastMessageUserId = ko.observable();
        this.lastMessageSentTime = ko.observable();
        this.unreadCount = ko.observable();
        this.sent = ko.pureComputed(function () {
            var currentUserId = _this.viewModel.currentUserId;
            return _this.lastMessageUserId() === currentUserId;
        });
        this.isActive = ko.pureComputed(function () {
            var currentChat = _this.viewModel.currentChat();
            if (currentChat) {
                return _this.id === currentChat.id;
            }
            return false;
        });
        this.id = data.id;
        this.title = data.title;
        this.isGroup = data.isGroup;
        this.avatarUrl = data.avatarUrl;
        this.lastActivity(moment(data.lastActivity));
        this.lastMessageId(data.lastMessageId);
        this.lastMessageText(data.lastMessageText);
        this.lastMessageUserId(data.lastMessageUserId);
        this.lastMessageSentTime(data.lastMessageSentTime);
        this.unreadCount(data.unreadCount);
        this.viewModel = viewModel;
    }
    return BaseChat;
}());
var PrivateChat = (function (_super) {
    __extends(PrivateChat, _super);
    function PrivateChat(data, viewModel) {
        var _this = this;
        _super.call(this, data, viewModel);
        this.unavailableMessage = ko.observable();
        this.isCurrentUserUnavailable = false;
        this.ignored = ko.observable();
        this.online = ko.pureComputed(function () {
            var lastActivity = _this.lastActivity();
            return moment.utc().add(-2, "minutes").isBefore(lastActivity);
        });
        this.allowSendPM = ko.pureComputed(function () {
            return !_this.ignoredByUser
                && !_this.ignored()
                && (_this.privacySendPM === PrivacyPrivateMessage.All || (_this.privacySendPM === PrivacyPrivateMessage.OnlyFriends && _this.isFriend))
                && !_this.isCurrentUserUnavailable;
        });
        this.showFeedbackForm = function () {
            window["AppComponents"].MobileFeedbackForm.show(_this.userId, "User", "/u/" + _this.userId);
        };
        this.userId = data.userId;
        this.privacySendPM = PrivacyPrivateMessage[data.privacyPrivateMessage];
        this.unavailableMessage(data.unavailableMessage);
        this.subscriptionInfoWithoutInvisible = data.subscriptionInfoWithoutInvisible;
        this.isFriend = data.subscriptionInfoWithoutInvisible
            && data.subscriptionInfoWithoutInvisible.targetUserSubscription
            && data.subscriptionInfoWithoutInvisible.targetUserSubscription.isMutual;
        this.isCurrentUserUnavailable = viewModel.isCurrentUserUnavailable;
        this.subscriptionInfo = data.subscriptionInfo;
        this.profileUrl = data.profileUrl;
        this.ignored(data.ignored);
        this.ignoredByUser = data.ignoredByUser;
        this.lastActivity(moment(data.lastActivity));
        this.isVerified = data.isVerified;
        setInterval(function () {
            _this.lastActivity(_this.lastActivity());
        }, 15000);
    }
    PrivateChat.prototype.lastActivityFromNow = function () {
        var lastActivity = this.lastActivity();
        return lastActivity.fromNow();
    };
    return PrivateChat;
}(BaseChat));
var GroupChat = (function (_super) {
    __extends(GroupChat, _super);
    function GroupChat(data, viewModel) {
        _super.call(this, data, viewModel);
        this.allowSendPM = ko.pureComputed(function () {
            return true;
        });
    }
    return GroupChat;
}(BaseChat));
var PMContact = (function () {
    function PMContact(data, viewModel) {
        var _this = this;
        this.isActive = ko.pureComputed(function () {
            var currentChat = _this.viewModel.currentChat();
            if (currentChat && !currentChat.isGroup) {
                return _this.userId === currentChat["userId"];
            }
            return false;
        });
        this.userId = data.userId;
        this.fio = data.fio;
        this.userName = "@" + data.userName;
        this.avatarUrl = data.avatarUrl;
        this.isVerified = data.isVerified;
        this.viewModel = viewModel;
    }
    return PMContact;
}());
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        var _this = this;
        _super.call(this, options);
        this.currentUserId = window["app"].userId;
        this.moreData = true;
        this.page = 1;
        this.recentChatsPage = 1;
        this.isResizeControls = false;
        this.messages = ko.observableArray();
        this.recentChats = ko.observableArray();
        this.orderedRecentChats = ko.pureComputed(function () {
            return _.sortBy(_this.recentChats(), function (x) {
                return moment(x.lastMessageSentTime()).toDate();
            }).reverse();
        });
        this.moreChats = ko.observable(true);
        this.searchResults = ko.observableArray();
        this.isCurrentUserUnavailable = false;
        this.currentChat = ko.observable(null);
        this.isLoading = ko.observable(false);
        this.redactorInitialized = ko.observable(false);
        this.isConnected = ko.observable(false);
        this.messageText = ko.observable("");
        this.selectedMessages = ko.observableArray();
        this.sendBtnDisable = ko.computed(function () {
            var isConnected = _this.isConnected();
            return !isConnected;
        });
        this.processing = ko.observable();
        this.searchQuery = ko.observable("");
        this.searchQueryWithRateLimit = ko.computed(function () {
            var query = _this.searchQuery();
            if (query.length > 0) {
                ajaxUtils_1.AjaxUtils.get("pm/searchContacts", { query: query })
                    .done(function (result) {
                    if (!result.isSuccessful) {
                        alert(result.messages[0]);
                        return;
                    }
                    var contacts = _.map(result.data, function (i) {
                        return new PMContact(i, _this);
                    });
                    _this.searchResults(contacts);
                });
            }
        }).extend({
            rateLimit: {
                timeout: 200,
                method: "notifyWhenChangesStop"
            }
        });
        this.deleteMessages = function () {
            if (_this.isLoading())
                return;
            var messages = _this.selectedMessages();
            var ids = _.map(messages, function (x) { return x.id; });
            app.f7.confirm("Вы уверены, что хотите удалить сообщение(-я)?", "Подтверждение", function () {
                _this.processing(true);
                ajaxUtils_1.AjaxUtils.post("pm/deleteMessages", { ids: ids })
                    .done(function (result) {
                    if (!result.isSuccessful) {
                        alert(result.messages[0]);
                        return;
                    }
                    _.each(messages, function (x) {
                        x.state("DeletedByUser");
                        x.allowEdit(false);
                    });
                    _this.selectedMessages([]);
                }).always(function () {
                    _this.isLoading(false);
                    _this.processing(false);
                });
                ;
            }, function () { });
        };
        this.selectChat = function (chat) {
            _this.currentChat(chat);
            _this.messages([]);
            _this.selectedMessages([]);
            _this.page = 1;
            _this.loadMessages(true);
            chat.unreadCount(0);
            setTimeout(function () {
                _this.resizeControls();
            }, 100);
        };
        this.selectContact = function (contact) {
            var chat = _.find(_this.recentChats(), function (c) {
                return !c.isGroup && c.userId === contact.userId;
            });
            var refreshMessages = function () {
                _this.messages([]);
                _this.page = 1;
                _this.loadMessages(true);
            };
            if (chat) {
                _this.currentChat(chat);
                chat.unreadCount(0);
                refreshMessages();
            }
            else {
                ajaxUtils_1.AjaxUtils.get("pm/privateChat", { userId: contact.userId })
                    .done(function (result) {
                    if (!result.isSuccessful) {
                        alert(result.messages[0]);
                        return;
                    }
                    var chat = new PrivateChat(result.data, _this);
                    _this.recentChats.push(chat);
                    _this.currentChat(chat);
                    refreshMessages();
                });
            }
        };
        this.sendMessage = function () {
            var messageText = _this.messageText();
            if (messageText === null || messageText === undefined || messageText.length === 0) {
                return;
            }
            if (_this.processing()) {
                return;
            }
            var chat = _this.currentChat();
            if (!chat)
                return;
            _this.processing(true);
            var messageData = {
                chatId: chat.id,
                text: messageText
            };
            var editingMessage = _this.editingMessage();
            if (editingMessage) {
                messageData.id = editingMessage.id;
            }
            ajaxUtils_1.AjaxUtils.post("pm/sendMessage", messageData).done(function (result) {
                if (!result.isSuccessful) {
                    alert(result.messages[0]);
                    return;
                }
                _this.messageText("");
                _this.editingMessage(null);
                _this.selectedMessages([]);
            }).always(function () {
                setTimeout(function () {
                    _this.processing(false);
                }, 100);
            });
        };
        this.selectMessage = function (message) {
            if ($(event.target).is("a"))
                return true;
            if (!message.allowEdit())
                return true;
            if (_this.editingMessage())
                return true;
            var alreadySelected = _this.selectedMessages().indexOf(message) !== -1;
            if (alreadySelected) {
                _this.selectedMessages.remove(message);
            }
            else {
                _this.selectedMessages.push(message);
            }
        };
        this.clearSelection = function () {
            _this.selectedMessages([]);
        };
        this.showTextForm = ko.pureComputed(function () {
            var chat = _this.currentChat();
            var editingMessage = _this.editingMessage();
            var messages = _this.selectedMessages();
            if (!chat || !chat.allowSendPM() || (chat.unavailableMessage()))
                return false;
            if (editingMessage)
                return true;
            return messages.length === 0;
        });
        this.editMessage = function () {
            var selectedMessages = _this.selectedMessages();
            if (selectedMessages.length !== 1)
                return;
            var messageText = _this.messageText();
            if (messageText && messageText.trim().length > 0) {
                app.f7.confirm("У вас есть неотправленное сообщение, которое будет утеряно. Продолжить?", "Подтверждение", function () {
                    _this.startEditingMessage();
                }, function () { });
            }
            else {
                _this.startEditingMessage();
            }
        };
        this.editingMessage = ko.observable();
        this.cancelEditingMessage = function () {
            _this.editingMessage(null);
            _this.messageText("");
            _this.selectedMessages([]);
        };
        this.userAvatarUrl = options.userAvatarUrl;
        this.isCurrentUserUnavailable = options.isCurrentUserUnavailable;
        this.loadRecentChats();
        $(function () {
            _this.mainView = app.f7.addView(".view-main", {
                domCache: true //enable inline pages
            });
            $(window).on("resize", function () {
                _this.resizeControls();
            });
            $("#popoverMore").appendTo(document.body);
            $(".messages-content").on("scroll.loadData", function () {
                if (_this.moreData && !_this.isLoading() && $(".messages-content").scrollTop() < 200) {
                    _this.loadMessages("more");
                }
            });
            $(".send-message-form textarea").on("froalaEditor.initialized", function (e, editor) {
                $(".send-message-form textarea").froalaEditor("events.focus");
            });
        });
    }
    ViewModel.prototype.resizeControls = function () {
        if (this.isResizeControls) {
            return;
        }
        var footerHeight = $(".toolbar-inner").height();
        var newToolbarHeight = footerHeight + 10;
        var windowHeight = $(window).height();
        var $content = $(".messages-content");
        var oldHeight = $content.height();
        var newHeight = windowHeight - newToolbarHeight - 56;
        var delta = oldHeight - newHeight;
        $(".messagebar").css("height", newToolbarHeight + "px");
        $content.css("height", newHeight + "px")
            .css("margin-bottom", newToolbarHeight + "px");
        $content.scrollTop($content.scrollTop() + delta);
        this.isResizeControls = true;
    };
    ViewModel.prototype.initRouting = function () {
        var _this = this;
        var routes = {
            "/index": function () {
                _this.mainView.loadPage("#index");
                _this.currentChat(null);
                _this.currentId = null;
                _this.searchQuery("");
                _this.searchResults([]);
                $(".searchbar-active").removeClass("searchbar-active");
            },
            "/search": function () {
                _this.mainView.loadPage("#search");
            },
            ":id": function (id) {
                if (_this.currentId == id) {
                    return;
                }
                _this.currentId = id;
                if (typeof id === "string" && id.indexOf("g") === 0) {
                }
                else {
                    var userId = parseInt(id);
                    _this.currentChat(null);
                    // Проверяем список чатов
                    var chat = _.find(_this.recentChats(), function (c) {
                        return !c.isGroup && c.userId === userId;
                    });
                    if (chat) {
                        _this.selectChat(chat);
                        return;
                    }
                    // Если не нашли ничего
                    ajaxUtils_1.AjaxUtils.get("pm/privateChat", { userId: userId })
                        .done(function (result) {
                        if (!result.isSuccessful) {
                            alert(result.messages[0]);
                            return;
                        }
                        var chat = new PrivateChat(result.data, _this);
                        _this.recentChats.push(chat);
                        _this.selectChat(chat);
                    });
                }
            }
        };
        this.router = director.Router(routes);
        this.router.init();
    };
    ViewModel.prototype.onIsOnline = function (userId) {
        _.each(this.recentChats(), function (c) {
            if (!c.isGroup && c.userId === userId) {
                c.lastActivity(moment.utc());
            }
        });
    };
    ;
    ViewModel.prototype.onNewMessage = function (message) {
        var _this = this;
        var currentChat = this.currentChat();
        var chat = _.find(this.recentChats(), function (c) {
            return c.id === message.chatId;
        });
        if (chat) {
            chat.lastMessageId(message.id);
            chat.lastMessageUserId(message.userId);
            chat.lastMessageText(stringUtils_1.default.clearFromTags(message.text));
            chat.lastMessageSentTime(moment(message.sentTime).toDate());
        }
        // Добавляем сообщение в текущий диалог, и помечаем как прочитанное
        if (currentChat && chat && currentChat.id === chat.id) {
            if (message.userId === this.currentUserId) {
                message.allowEdit = true;
            }
            this.messages.push(this.toMessage(message));
            setTimeout(function () {
                var $content = $(".messages-content");
                $content.scrollTop($(".messages").height() - $content.height() + 300);
                var messages = $(".messages");
                imageZoomUtils_1.default.init(messages[messages.length - 1]);
            }, 50);
            if (message.userId !== this.currentUserId) {
                ajaxUtils_1.AjaxUtils.post("pm/markAsRead", { id: chat.id });
            }
            return;
        }
        this.reloadNotificationCount();
        if (chat) {
            if (message.userId !== this.currentUserId) {
                chat.unreadCount(chat.unreadCount() + 1);
                chat.lastActivity(new Date());
            }
        }
        else {
            if (!message.isGroupChat) {
                // Если не нашли ничего
                ajaxUtils_1.AjaxUtils.get("pm/privateChat", { userId: message.userId })
                    .done(function (result) {
                    if (!result.isSuccessful) {
                        alert(result.messages[0]);
                        return;
                    }
                    var chat = new PrivateChat(result.data, _this);
                    _this.recentChats.push(chat);
                });
            }
            else {
            }
        }
    };
    ViewModel.prototype.messageUpdate = function (message) {
        var currentChat = this.currentChat();
        var chat = _.find(this.recentChats(), function (c) {
            return c.id === message.chatId;
        });
        if (currentChat && chat && currentChat.id === chat.id) {
            var messageToUpdate = _.find(this.messages(), function (x) { return x.id === message.id; });
            if (messageToUpdate) {
                messageToUpdate.text(message.text);
                messageToUpdate.lastModificationTime(message.lastModificationTime);
                setTimeout(function () {
                    var messages = $(".message");
                    imageZoomUtils_1.default.init(messages[messages.length - 1]);
                }, 50);
            }
        }
    };
    ViewModel.prototype.loadRecentChats = function () {
        var _this = this;
        if (!this.moreChats()) {
            return;
        }
        app.f7.showIndicator();
        if (this.recentChatsPage === 1) {
            this.isLoading(true);
        }
        ajaxUtils_1.AjaxUtils.get("pm/recentChats", { page: this.recentChatsPage })
            .done(function (result) {
            if (!result.isSuccessful) {
                alert(result.messages[0]);
                return;
            }
            var chats = _.map(result.data.chats, function (i) {
                return i.isGroup ? new GroupChat(i, _this) : new PrivateChat(i, _this);
            });
            ko.utils.arrayPushAll(_this.recentChats, chats);
            _this.moreChats(result.data.more);
            _this.recentChatsPage++;
            if (!_this.isConnected()) {
                var hub = $.connection["notificationHub"];
                hub.client.chatNewMessage = function (message) {
                    _this.onNewMessage(message);
                };
                hub.client.chatMessageUpdate = function (message) {
                    _this.messageUpdate(message);
                };
                hub.client.isOnline = function (message) {
                    _this.onIsOnline(message);
                };
                $.connection.hub.start({ transport: ["webSockets", "longPolling"] })
                    .done(function () {
                    _this.isConnected(true);
                    console.log("Connected, transport: " + $.connection.hub.transport.name + ", connection ID: " + hub.connection.id);
                });
                $.connection.hub.disconnected(function () {
                    _this.isConnected(false);
                    console.log("Disconnected.");
                    setTimeout(function () {
                        $.connection.hub.start({ transport: ["webSockets", "longPolling"] })
                            .done(function () {
                            _this.isConnected(true);
                            console.log("Connected, transport: " + $.connection.hub.transport
                                .name + ", connection ID: " + hub.connection.id);
                        });
                    }, 3000);
                });
                _this.isLoading(false);
                app.f7.hideIndicator();
                _this.initRouting();
            }
            else {
                _this.isLoading(false);
                app.f7.hideIndicator();
            }
        });
    };
    ViewModel.prototype.loadMessages = function (scrollDown) {
        var _this = this;
        if (this.currentAjaxRequest) {
            this.currentAjaxRequest.abort();
        }
        var chat = this.currentChat();
        if (!chat)
            return;
        if (scrollDown && scrollDown !== "more") {
            this.mainView.loadPage("#dialog");
        }
        this.isLoading(true);
        var $messages = $(".messages");
        var currentHeight = $messages.height();
        app.f7.showIndicator();
        this.currentAjaxRequest = ajaxUtils_1.AjaxUtils.get("pm/messages", {
            id: chat.id,
            page: this.page
        })
            .done(function (result) {
            if (!result.isSuccessful) {
                alert(result.messages[0]);
                return;
            }
            _this.reloadNotificationCount();
            _this.moreData = result.data.more;
            _this.page++;
            var messages = _.map(result.data.messages, function (i) { return _this.toMessage(i); });
            _.each(messages, function (m) {
                _this.messages.unshift(m);
            });
            setTimeout(function () {
                var $content = $(".messages-content");
                if (scrollDown !== "more") {
                    $content.scrollTop($(".messages").height() - $content.height() + 300);
                }
                else {
                    var deltaHeight = $messages.height() - currentHeight;
                    $content.scrollTop(deltaHeight);
                }
                imageZoomUtils_1.default.init($content);
                _this.isLoading(false);
                app.f7.hideIndicator();
            }, 50);
        });
    };
    ViewModel.prototype.reloadNotificationCount = function () {
        var component = window["AppComponents"].MobileNotifications;
        if (component) {
            component.reload();
        }
    };
    ViewModel.prototype.clearSearchQuery = function () {
        this.searchQuery("");
    };
    ViewModel.prototype.startEditingMessage = function () {
        var _this = this;
        var message = this.selectedMessages()[0];
        var originalText = richContentUtils_1.default.htmlToPlainText(message.text());
        this.editingMessage(message);
        setTimeout(function () {
            _this.messageText(originalText);
            $(".send-message-form textarea").focus();
        });
    };
    ViewModel.prototype.toMessage = function (data) {
        data.isMy = data.userId === this.currentUserId;
        data.text = ko.observable(data.text);
        if (data.state === 1) {
            data.state = "Default";
        }
        data.state = ko.observable(data.state);
        data.allowEdit = ko.observable(data.allowEdit);
        data.lastModificationTime = ko.observable(data.lastModificationTime);
        if (data.userAvatarUrl) {
            data.styleAttr = "background-image: url('" + data.userAvatarUrl + "')";
        }
        return data;
    };
    return ViewModel;
}(baseViewModel_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=pmIndex.js.map